export default function IconRightArrow() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M15.5146 13.7277C16.1618 13.0745 16.1618 12.0154 15.5146 11.3622L10.9574 6.76266C10.6697 6.47234 10.2034 6.47234 9.91573 6.76266C9.62809 7.05297 9.62809 7.52366 9.91573 7.81398L14.473 12.4135C14.5449 12.4861 14.5449 12.6038 14.473 12.6763L9.91573 17.2759C9.62809 17.5662 9.62809 18.0369 9.91573 18.3272C10.2034 18.6175 10.6697 18.6175 10.9574 18.3272L15.5146 13.7277Z"
            fill="#7E8681"/>
    </svg>
  )
}
